import {
  CheckCircleFilled,
  CheckOutlined,
  ContainerOutlined,
  ExclamationCircleFilled,
  ExclamationOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Divider, Space, Tag, Typography, Flex } from "antd";
import PropTypes from "prop-types";

import { ChallengeBgIcon } from "./ChallengeBgIcon.jsx";
import { formatTimestamp } from "../helpers/common.js";

function ChallengeDetailCard({ data, padding, onClick, isActive }) {
  const typeIconMap = {
    extraction: { icon: <FileDoneOutlined />, bgColor: "blue" },
    challenge: { icon: <ContainerOutlined />, bgColor: "gold" },
    resultSuccess: { icon: <CheckOutlined />, bgColor: "green" },
    resultFailed: { icon: <ExclamationOutlined />, bgColor: "red" },
  };
  const statusIconMap = {
    success: <CheckCircleFilled className="challenge-success" />,
    failed: <ExclamationCircleFilled className="challenge-failed" />,
  };
  const isTypeResult = data?.type === "result";
  const isTypeChallenge = data?.type === "challenge";
  let typeIconMapKey = data?.type;
  if (isTypeResult) {
    const postfix = data?.status === "success" ? "Success" : "Failed";
    typeIconMapKey += postfix;
  }
  // Determine the score to display
  let score = 0;
  if (data?.score) {
    score = data.score;
  } else if (data?.status === "success") {
    score = "5";
  }
  let scoreText = ` ${score}/5 `;
  if (score > 2) {
    scoreText += "Passed";
  } else {
    scoreText += "Failed";
  }
  let resultData = data?.result;
  if (resultData && typeof resultData === "object") {
    resultData = JSON.stringify(resultData);
  }

  return (
    <>
      <Divider className="prompt-card-divider" />
      <div
        style={{ "--padding-left": `${padding}px` }}
        onClick={onClick}
        className={`challenge-detail-card cursor-pointer ${
          isActive ? "active" : ""
        }`}
      >
        <Space className={`challenge-card-comp-layout ${typeIconMapKey}`}>
          <Flex className="challenge-card-head-content" justify="space-between">
            <Tag color={typeIconMap?.[typeIconMapKey]?.["bgColor"]}>
              {data?.title}
            </Tag>
            <Typography.Text>
              {formatTimestamp(data?.timestamp)}
            </Typography.Text>
          </Flex>
          <Flex>
            <ChallengeBgIcon
              icon={typeIconMap?.[typeIconMapKey]?.["icon"] || <></>}
              type={typeIconMapKey}
            />
            <Flex vertical className="challenger-result-container">
              {!isTypeResult && (
                <Typography.Text>{data?.heading}</Typography.Text>
              )}
              <Typography.Text ellipsis>
                {!isTypeResult && (
                  <>
                    <span>Result: </span>
                    {isTypeChallenge && (
                      <>
                        {statusIconMap?.[data?.status] || <></>}
                        <strong>{scoreText} </strong>
                      </>
                    )}
                  </>
                )}
                {resultData}
              </Typography.Text>
            </Flex>
          </Flex>
        </Space>
      </div>
    </>
  );
}

ChallengeDetailCard.propTypes = {
  padding: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export { ChallengeDetailCard };
